import { render } from "./IndicatorSettings.vue?vue&type=template&id=3bd9ec0b"
import script from "./IndicatorSettings.vue?vue&type=script&lang=js"
export * from "./IndicatorSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__